module.exports = __webpack_public_path__ + "img/43.217c4d21.jpg";